import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { NewReports } from '@/modules/Reports';

const NewReportsPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }
  return (
    <Box width="100%">
      <Box align="center">
        <Box width="100%">
          <NewReports />
        </Box>
      </Box>
    </Box>
  );
};

export default NewReportsPage;
